import React from 'react'
import PropTypes from 'prop-types'

const TableHeader = ({ children, classes }) => (
  <thead className={classes}>
    <tr>{children}</tr>
  </thead>
)

TableHeader.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
}

export default TableHeader
